import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-696ee2e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "block container-box notice-box" }
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 0,
  class: "dot dot-red"
}
const _hoisted_4 = { class: "notice-detail" }
const _hoisted_5 = { class: "notice-head row" }
const _hoisted_6 = { class: "notice-title" }
const _hoisted_7 = { class: "notice-date" }
const _hoisted_8 = { class: "notice-content" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))

import { ref } from 'vue'
import { getMessage, MessageDto } from '@/api/message'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const messageList = ref([] as MessageDto[])
const pageNum = ref(1)
const pageSize = ref(10)
const total = ref(1)
const handleCurrentChange = async () => {
    const result = await getMessage({
        page: pageNum.value,
        pageSize: pageSize.value
    })
    messageList.value = result.data
    total.value = result.total
}
const handleSizeChange = () => {
    pageNum.value = 1
    handleCurrentChange()
}
handleCurrentChange()

return (_ctx: any,_cache: any) => {
  const _component_page_head = _resolveComponent("page-head")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_page_head, { title: "消息" }),
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(messageList.value, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "notice",
          key: index
        }, [
          _createElementVNode("img", {
            class: "notice-icon",
            src: item.icon
          }, null, 8, _hoisted_2),
          (!item.status)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, _toDisplayString(item.title), 1),
              _createElementVNode("div", _hoisted_7, _toDisplayString(item.create_time), 1)
            ]),
            _createElementVNode("div", _hoisted_8, _toDisplayString(item.content), 1)
          ])
        ]))
      }), 128)),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createVNode(_component_el_pagination, {
          class: "pagination",
          currentPage: pageNum.value,
          "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => ((pageNum).value = $event)),
          "page-size": pageSize.value,
          "onUpdate:page-size": _cache[1] || (_cache[1] = ($event: any) => ((pageSize).value = $event)),
          "page-sizes": [10, 30, 50, 100],
          layout: "total, sizes, prev, pager, next, jumper",
          total: total.value,
          onSizeChange: handleSizeChange,
          onCurrentChange: handleCurrentChange
        }, null, 8, ["currentPage", "page-size", "total"])
      ])
    ])
  ], 64))
}
}

})